import styled from "styled-components";

export const Wrapper = styled.div`
  padding-top: 90px;
`;

export const Card = styled.div`
  width: 115%;
  display: grid;
  border-radius: 23px;
  grid-gap: 2rem;
  margin-left: -50px;
  margin-bottom: 70px;
  padding: 12px;
  grid-template-columns: 1fr;
  border-bottom: 1px solid rgb(0, 0, 0);
  transition: box-shadow 0.9s ease, transform 0.5s ease; 

  @media (min-width: 992px) {
    grid-template-columns: 1fr 1fr;
    border-bottom: 0;
    padding-bottom: 0;
    width: auto; /* Change the width to auto within the media query */
    margin-left: 0; /* Remove negative margin-left within the media query */
  }


  &:hover {
    // box-shadow: rgba(0, 0, 0, 0.56) 0px 22px 70px 4px;
    box-shadow: rgb(100, 98, 98) 0px 22px 70px 4px;
    transform: scale(1.05); 
  }
`;

export const CardLeft = styled.div`
  
  border-radius: 5px;
  padding: 5px;
  justify-self: center;
  height: 100%; 
  display: flex;
  align-items: center;
  max-width: 100%; 

  img {
    border: 0.5px solid gray;
    max-height: 100%; 
    max-width: 100%;
    border-radius: 3px;
  }
`;

export const CardRight = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 100%; /* Set a max-width for CardRight to limit its width */

  h4 {
    font-size: 1.5rem;
    font-weight: 700;
  }

  p {
    font-weight: 500;
    margin-top: 10px;
    margin-bottom: 1rem;
    color: rgba(0, 0, 0, 0.815);
    text-align: left;

    @media (min-width: 992px) {
      text-align: start;
    }
  }

  @media (min-width: 992px) {
    align-items: flex-start;
    margin-top: 1rem;
  }
`;

export const Stack = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;

  .stackTitle {
    font-weight: 500;
    margin-right: 10px;
    font-size: 16px;
  }

  .tags {
    font-size: 15px;
    font-weight: 400;
  }
`;

export const BtnGroup = styled.div`
  height: 70px;
  display: flex;
  align-items: center;
`;
